module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1IeA23/tc-custom/9781439666685.jpg?1704586003253",
      "alt": "This image is the cover for the book A History of Iowa Wine, American Palate"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("A History of Iowa Wine, American Palate\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Iowa has a history with grapevines that goes back more than a century. New York lawyer Hiram Barney obtained a tract of land in southeast Iowa as part of the Half-Breed program following the American Indian Wars and created the White Elk Winery. German settlers in Amana tended community vineyards for communal wines. Before Prohibition, the Council Bluffs Grape Growers Association grew grapes and shipped them eastward by the ton. In the early 1900s, the state was among the nation's top producers of grapes. Pesticides, weather and government subsidies ended the time of the vines of the prairie until their recent return. Author John N. Peragine details the rise, fall and resurgence of the industry in the Hawkeye State.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      John N. Peragine\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("John Peragine is a published author of thirteen books and has ghostwritten many others. He has written for the New York Times, Reuters and Bloomberg news as a journalist. John also writes for magazines such as Writer's Digest, Wine Enthusiast, Acres USA Magazine and Speaker Magazine (National Speakers Association), just to name a few. John has been writing professionally since 2007 after working thirteen years in the field of social work, and he was the piccolo player for the Western Piedmont Symphony for twenty-four years. John lives with his wife and children on the bluffs in Davenport, Iowa, overlooking the Mississippi River. When he is not writing, he is working with his grapes in the L'oste Vineyard.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0